(() => {
  if (window.worldsImageViewerReady) return;
  window.worldsImageViewerReady = true;
  const original = (source) => {
    try {
      const url = new URL(source, window.location.href);
      const shopifySource = url.hostname === 'cdn.shopify.com' || (url.origin === window.location.origin && url.pathname.startsWith('/cdn/shop/'));
      if (url.protocol !== 'https:' || !shopifySource) return '';
      ['width', 'height', 'crop', 'pad', 'scale'].forEach((key) => url.searchParams.delete(key));
      return url.href;
    } catch (_) { return ''; }
  };
  const init = (scope = document) => scope.querySelectorAll('[data-worlds-image-gallery]').forEach((gallery) => {
    if (gallery.dataset.imageViewerReady) return;
    const main = gallery.querySelector('[data-worlds-image-main]');
    const trigger = gallery.querySelector('[data-worlds-image-open]');
    const dialog = gallery.querySelector('[data-worlds-image-dialog]');
    if (!main || !trigger || !dialog || typeof dialog.showModal !== 'function') return;
    gallery.dataset.imageViewerReady = 'true';
    const closeButton = dialog.querySelector('[data-image-close]');
    const fitButton = dialog.querySelector('[data-image-fit]');
    const nativeButton = dialog.querySelector('[data-image-native]');
    const link = dialog.querySelector('[data-image-original]');
    const viewport = dialog.querySelector('[data-image-viewport]');
    const image = dialog.querySelector('[data-image-full]');
    const status = dialog.querySelector('[data-image-status]');
    let serial = 0;
    let source = '';
    let width = 0;
    let height = 0;
    let mode = 'fit';
    let returnFocus;
    let previousOverflow;
    const fit = () => {
      if (!width || !height) return;
      const dpr = Math.max(1, window.devicePixelRatio || 1);
      const nativeWidth = width / dpr;
      const nativeHeight = height / dpr;
      const ratio = mode === 'native' ? 1 : Math.min(1, viewport.clientWidth / nativeWidth, viewport.clientHeight / nativeHeight);
      image.style.width = `${nativeWidth * ratio}px`;
      image.style.height = `${nativeHeight * ratio}px`;
      fitButton.setAttribute('aria-pressed', String(mode === 'fit'));
      nativeButton.setAttribute('aria-pressed', String(mode === 'native'));
    };
    const close = () => {
      serial += 1;
      if (!dialog.open) return;
      dialog.close();
    };
    const update = async () => {
      const nextSource = original(main.dataset.zoomOriginal || '');
      if (!nextSource) return;
      trigger.href = nextSource;
      if (!dialog.open || source === nextSource) return;
      source = nextSource;
      const request = ++serial;
      width = 0; height = 0; mode = 'fit';
      image.hidden = true;
      image.removeAttribute('src');
      image.removeAttribute('srcset');
      fitButton.disabled = true; nativeButton.disabled = true;
      viewport.setAttribute('aria-busy', 'true');
      status.textContent = dialog.dataset.imageLoading;
      link.href = nextSource;
      const pending = new Image();
      pending.decoding = 'async';
      try {
        await new Promise((resolve, reject) => {
          pending.onload = resolve;
          pending.onerror = reject;
          pending.src = nextSource;
        });
        if (pending.decode) await pending.decode();
        if (request !== serial || !dialog.open) return;
        width = pending.naturalWidth; height = pending.naturalHeight;
        if (!width || !height) throw new Error('image-dimensions-unavailable');
        image.src = nextSource;
        image.alt = main.alt;
        image.width = width; image.height = height;
        image.hidden = false;
        fitButton.disabled = false; nativeButton.disabled = false;
        viewport.scrollTop = 0; viewport.scrollLeft = 0;
        fit();
        status.textContent = dialog.dataset.imageLoaded.replace('__WIDTH__', String(width)).replace('__HEIGHT__', String(height));
      } catch (_) {
        if (request !== serial || !dialog.open) return;
        source = '';
        status.textContent = dialog.dataset.imageError;
      } finally {
        if (request === serial) viewport.setAttribute('aria-busy', 'false');
      }
    };
    trigger.addEventListener('click', (event) => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || !original(main.dataset.zoomOriginal || '')) return;
      event.preventDefault();
      returnFocus = document.activeElement;
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      source = '';
      dialog.showModal();
      closeButton.focus();
      update();
    });
    closeButton.addEventListener('click', close);
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    dialog.addEventListener('close', () => {
      serial += 1; source = '';
      document.body.style.overflow = previousOverflow || '';
      if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) close(); });
    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); close(); return; }
      if (event.key !== 'Tab') return;
      const controls = [...dialog.querySelectorAll('button:not(:disabled), a[href], [tabindex="0"]')];
      const first = controls[0]; const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    fitButton.addEventListener('click', () => { mode = 'fit'; fit(); viewport.scrollTop = 0; viewport.scrollLeft = 0; });
    nativeButton.addEventListener('click', () => { mode = 'native'; fit(); viewport.focus(); });
    gallery.addEventListener('worlds:image-change', update);
    window.addEventListener('resize', fit);
    document.addEventListener('shopify:section:unload', (event) => { if (event.target.contains(gallery)) close(); });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
